import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, DEG_TO_RAD, Text, Sprite, TextStyle } from "pixi.js";
import OptionBtn from "./optionBtn";
export default class Parametres extends Container {
  constructor(blackLayer, onShow, onHide) {
    super();
    this.build = this.build.bind(this);
    this.show = this.show.bind(this);
    this.onCloseDown = this.onCloseDown.bind(this);
    this.onCloseUp = this.onCloseUp.bind(this);
    this.onCloseOut = this.onCloseOut.bind(this);
    this.onSoundClick = this.onSoundClick.bind(this);
    this._layer = blackLayer;
    this._onHide = onHide;
    this._onShow = onShow;
    this.build();
  }
  build() {
    this.bg = new Sprite(assets.textures.popinBg.texture);
    this.bg.scale.set(.7);
    this.bg.anchor.set(.5);
    this.addChild(this.bg);
    this.close = new Sprite(assets.textures.close.texture);
    this.close.position.set(this.bg.width * .45, -this.bg.height * .45);
    this.close.anchor.set(.5);
    this.close.interactive = true;
    this.close.buttonMode = true;
    this.close.on('pointerdown', this.onCloseDown);
    this.close.on('pointerup', this.onCloseUp);
    this.close.on('pointerupoutside', this.onCloseOut);
    this.addChild(this.close);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 50,
      align: "center",
      fill: config.failTextColor,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 4,
      dropShadowColor: '0x000000',
      dropShadowDistance: 6
    });
    this.text = new Text(assets.local.parametres, textStyle);
    this.text.anchor.set(.5);
    this.text.position.set(0, -150);
    this.addChild(this.text);
    this.haptic = new OptionBtn(assets.textures.haptiqueOn.texture, assets.local.haptic);
    this.haptic.x = -110;
    this.haptic.y = 0;
    this.haptic.click = () => {
      this.enableHaptic = this.hapticActive;
    };
    this.addChild(this.haptic);
    this.visible = false;
  }
  init() {
    config.youtubePlayables && config.youtubePlayables.syncAudioFromYouTube();
    if (config.haptic == null) {
      if (config.platform == "android") {
        this.hapticActive = true;
        this.enableHaptic = this.hapticActive;
      } else {
        this.hapticActive = true;
        config.haptic = true;
      }
    } else {
      this.hapticActive = config.haptic;
      if (this.hapticActive == false) {
        this.hapticActive = true;
        this.enableHaptic = this.hapticActive;
      }
    }
  }
  onSoundClick() {
    // Audio is controlled by YouTube Playables. Custom sound toggles are disabled.
    config.youtubePlayables && config.youtubePlayables.syncAudioFromYouTube();
  }
  set enableHaptic(val) {
    this._enableHaptic = val;
    if (this.hapticActive) {
      this.haptic.texture = assets.textures.haptiqueOff.texture;
      config.haptic = false;
    } else {
      this.haptic.texture = assets.textures.haptiqueOn.texture;
      config.haptic = true;
    }
    this.hapticActive = !this.hapticActive;
    config.sdk.getStoreModule().save("haptic", {
      value: config.haptic
    });
  }
  onCloseDown(event) {
    if (!this._closeDown) {
      this._closeDown = true;
      gsap.to(this.close.scale, {
        duration: .2,
        x: .8,
        y: .8
      });
    }
  }
  onCloseUp(event) {
    if (this._closeDown) {
      this.hide();
    }
    this._closeDown = false;
  }
  onCloseOut(event) {
    this._closeDown = false;
    gsap.to(this.close.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
  }
  show() {
    config.boosterPopin.hide();
    this._layer.visible = true;
    config.level.addChildAt(this._layer, 2);
    this.close.visible = true;
    this._onShow && this._onShow();
    this.scale.set(.3);
    this.visible = true;
    gsap.to(this.scale, {
      duration: .5,
      x: 1,
      y: 1,
      ease: "back.out(2)"
    });
  }
  hide() {
    this._layer.visible = false;
    config.level.removeChild(this._layer);
    this.close.visible = false;
    gsap.to(this.scale, {
      duration: .2,
      x: .3,
      y: .3,
      onComplete: () => {
        this.visible = false;
        this._onHide && this._onHide();
      }
    });
  }
  hideSound() {
    this.haptic.y = 0;
  }
}
